import React from "react";

interface Producto {
  id: number;
  nombre: string;
  descripcion: string;
  precio: string;
  imagen: string;
}

interface CardProductoProps {
  producto: Producto;
}

const CardProducto: React.FC<CardProductoProps> = ({ producto }) => (
  <div className="card">
        <img src={producto.imagen} alt={producto.nombre} />
        <h2>{producto.nombre}</h2>
        <p>{producto.descripcion}</p>
        <p>{producto.precio}</p> {" "}
  </div>
);

export default CardProducto;
